import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#FAFAF8] noise-bg flex items-center justify-center px-6">
      <div className="card-warm w-full max-w-md p-10 text-center" data-testid="payment-cancel-page">
        <h1 className="font-heading text-3xl font-semibold" data-testid="payment-cancel-heading">Checkout cancelled</h1>
        <p className="text-sm text-[#5C5C57] mt-3">No charge was made. You can resume whenever you're ready.</p>
        <Link to="/app">
          <Button data-testid="cancel-back-btn" className="mt-8 rounded-full bg-[#1E3F20] hover:bg-[#2C5A2E] text-white">Back to my portal</Button>
        </Link>
      </div>
    </div>
  );
}
